// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__3XtHx","breadcrumb":"Breadcrumbs_breadcrumb__JSS6m"};